// extracted by mini-css-extract-plugin
export default {"mainContainer":"bk_f2","contentViewport":"bk_f3"};